export default "__VITE_ASSET__DYFAdvbS__"